import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JSConfetti from 'js-confetti';
import { FormattedMessage } from 'react-intl';

import imgixConfig from 'Config/imgix';
import MysteryRevealCard from 'Components/Order/KeyReveals/MysteryRevealCard';

import 'Components/Order/KeyReveals/Envelope/EnvelopeReveal.scss';

export default function EnvelopeReveal({
  uniqueId,
  item,
  viewKeys,
  testReveal,
  testGame,
}) {
  const [revealed, setRevealed] = useState(false);
  const [canvas, setCanvas] = useState(null);
  const [showText, setShowText] = useState(false);

  const canvasRef = useRef(canvas);

  const openTheEnvelope = useCallback(() => {
    const jsConfetti = new JSConfetti({ canvas });
    // Check canvas exists
    if (canvasRef.current === canvas) {
      jsConfetti.addConfetti({
        confettiColors: [
          '#f56300',
          '#d92202',
          '#976d00',
          '#d4cb42',
          '#832501',
          '#320105',
          '#000000',
          '#ffffff',
        ],
      });
    }

    window.setTimeout(() => {
      setShowText(true);
    }, 2500);

    return setRevealed(true);
  }, [canvas]);

  useEffect(() => {
    canvasRef.current = document.getElementById(`confetti-envelope-canvas-${uniqueId}`);
    setCanvas(canvasRef.current);
    setTimeout(() => { openTheEnvelope(); }, 1000);
  }, [openTheEnvelope, canvas, setCanvas, uniqueId]);

  return (
    <>
      <div className="EnvelopeReveal">
        <div className="EnvelopeReveal__wrapper">
          <div className={`EnvelopeReveal__envelope ${revealed ? 'EnvelopeReveal__envelope--open' : 'EnvelopeReveal__envelope--closed'}`}>
            <div className="EnvelopeReveal__envelope__seal">
              <div className="EnvelopeReveal__envelope__seal__golding">
                <img src={`https://fanatical.imgix.net/production/assets/misc/lunar-letter-motif.png?${imgixConfig}`} alt="motif" />
              </div>
            </div>

            <div className="EnvelopeReveal__envelope__pocket" />

            <div className="EnvelopeReveal__envelope__letter">
              <MysteryRevealCard
                soundOn={false}
                game={testReveal ? testGame : item}
              />
            </div>

            <div className="EnvelopeReveal__envelope__leftMotif">
              <img src={`https://fanatical.imgix.net/production/assets/misc/lunar-letter-motif.png?${imgixConfig}`} alt="motif" />
            </div>
            <div className="EnvelopeReveal__envelope__rightMotif">
              <img src={`https://fanatical.imgix.net/production/assets/misc/lunar-letter-motif.png?${imgixConfig}`} alt="motif" />
            </div>
          </div>
        </div>

        {testReveal &&
          <div className={classNames('EnvelopeReveal__openText', { 'EnvelopeReveal__openText--visible': showText })}>
            <FormattedMessage id="envelope-reveal.test-text" defaultMessage="Now you’ve tried it, get your envelope and see what you find!" />
          </div>
        }

        {showText && !testReveal &&
          <button className="MysteryReveal__revealButton MysteryReveal__revealButton--envelope mt-4" onClick={() => { viewKeys(); }}>
            <FormattedMessage id="envelope-reveal.button.view-key" defaultMessage="View your key" />
          </button>
        }
      </div>
      <canvas id={`confetti-envelope-canvas-${uniqueId}`} className="envelopeCanvas" />
    </>
  );
}

EnvelopeReveal.propTypes = {
  item: PropTypes.shape({}),
  testGame: PropTypes.shape({}),
  viewKeys: PropTypes.func,
  testReveal: PropTypes.bool,
  uniqueId: PropTypes.string,
};

EnvelopeReveal.defaultProps = {
  item: {},
  testGame: {},
  viewKeys: () => {},
  testReveal: false,
  uniqueId: '',
};
